import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { ApiError } from '../api/client'
import { useRedeemResetCode } from './useOnboarding'

// Öffentliche Passwort-Zurücksetzung per Reset-Einmal-ID (vom Chef ausgegeben). Kein Login nötig.
// Nach Erfolg: Bestätigung + Link zur Anmeldung (man meldet sich mit dem neuen Passwort an).
export function ResetCodePage() {
  const redeem = useRedeemResetCode()
  const [code, setCode] = useState('')
  const [password, setPassword] = useState('')

  function onSubmit(e: FormEvent) {
    e.preventDefault()
    redeem.mutate({ code: code.trim(), password })
  }

  const errorMessage = redeem.error instanceof ApiError ? redeem.error.message : redeem.isError ? 'Zurücksetzen fehlgeschlagen' : null

  if (redeem.isSuccess) {
    return (
      <div className="centered">
        <div className="card login">
          <h1>Passwort geändert</h1>
          <p className="hint">Dein Passwort wurde gesetzt. Du kannst dich jetzt mit dem neuen Passwort anmelden.</p>
          <Link to="/login" className="btn">
            Zur Anmeldung
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="centered">
      <form className="card login" onSubmit={onSubmit}>
        <h1>Passwort zurücksetzen</h1>
        <p className="hint">Gib den Reset-Code deines Chefs und ein neues Passwort ein.</p>
        <label className="field">
          <span>Reset-Code</span>
          <input
            name="code"
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck={false}
            placeholder="WF-RST-XXXX-XXXX-XXXX"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
          />
        </label>
        <label className="field">
          <span>Neues Passwort (min. 8 Zeichen)</span>
          <input name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {errorMessage && (
          <p className="error" role="alert">
            {errorMessage}
          </p>
        )}
        <button type="submit" className="btn" disabled={redeem.isPending}>
          {redeem.isPending ? 'Wird gesetzt…' : 'Passwort setzen'}
        </button>
        <nav className="wf-legalfoot" aria-label="Navigation">
          <Link to="/login">Zurück zur Anmeldung</Link>
        </nav>
      </form>
    </div>
  )
}
